import { render, staticRenderFns } from "./LolerSearch.vue?vue&type=template&id=60fcd7f0&scoped=true"
import script from "./LolerSearch.vue?vue&type=script&lang=js"
export * from "./LolerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fcd7f0",
  null
  
)

export default component.exports